export const inner_route_tags_user_groups = "/corporate/usergroups";
export const inner_route_tags_user_groups_users = "/corporate/usergroups/user";
